import Vue from 'vue'
import VueRouter from 'vue-router'
import Signup from '../views/Session/Signup/Index.vue'
import SignupStep1 from '../views/Session/Signup/Step1.vue'
import SignupStep2 from '../views/Session/Signup/Step2.vue'
import Login from '../views/Session/Login.vue'
import ChangePassword from '../views/Session/ChangePassword.vue'
import ForgotPassword from '../views/Session/ForgotPassword.vue'
import MasterLogin from '../views/Session/MasterLogin.vue'
import Tasks from '../views/Tasks/Index.vue'

/** LAZY LOADING **/
/*const EmailConfirmation = resolve => {
  require.ensure(['../views/Sessions/EmailConfirmation/Index.vue'], () => {
    resolve(require('../views/Sessions/EmailConfirmation/Index.vue'))
})
}
/** END LAZY LOADING **/

Vue.use(VueRouter)

const routes = [
  { path: '/signup', component: Signup,  meta: { requiresAuth: false } },
  { path: '/signup/step1', component: SignupStep1,  meta: { requiresAuth: false } },
  { path: '/signup/step2', component: SignupStep2,  meta: { requiresAuth: false } },
  
  { path: '/login', component: Login,  meta: { requiresAuth: false } },
  { path: '/masteraccount', component: MasterLogin,  meta: { requiresAuth: false } },
  { path: '/changepassword', component: ChangePassword,  meta: { requiresAuth: true } },
  { path: '/forgotpassword', component: ForgotPassword,  meta: { requiresAuth: false } },
  { path: '/tasks', component: Tasks,  meta: { requiresAuth: true } },
    
  { path: '/preferences', component: (resolve) => {
      require.ensure(['../views/Preferences/Index.vue'], () => {
        resolve(require('../views/Preferences/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/verifygoogleauthcode', component: (resolve) => {
    require.ensure(['../components/VerifyGoogleAuth.vue'], () => {
      resolve(require('../components/VerifyGoogleAuth.vue'))
    })
  },  meta: { requiresAuth: true } },
  
  { path: '/shops', component: (resolve) => {
      require.ensure(['../views/Shop/Index.vue'], () => {
        resolve(require('../views/Shop/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/shops/form', component: (resolve) => {
      require.ensure(['../views/Shop/Form/Index.vue'], () => {
        resolve(require('../views/Shop/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/taskcategories', component: (resolve) => {
      require.ensure(['../views/TaskCategory/Index.vue'], () => {
        resolve(require('../views/TaskCategory/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/taskcategories/form', component: (resolve) => {
      require.ensure(['../views/TaskCategory/Form/Index.vue'], () => {
        resolve(require('../views/TaskCategory/Form/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  
  { path: '/teamcategories', component: (resolve) => {
      require.ensure(['../views/TeamMaster/Index.vue'], () => {
        resolve(require('../views/TeamMaster/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/teamcategories/form', component: (resolve) => {
      require.ensure(['../views/TeamMaster/Form/Index.vue'], () => {
        resolve(require('../views/TeamMaster/Form/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  
  { path: '/salescategory', component: (resolve) => {
      require.ensure(['../views/SaleCategory/Index.vue'], () => {
        resolve(require('../views/SaleCategory/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/salescategory/form', component: (resolve) => {
      require.ensure(['../views/SaleCategory/Form/Index.vue'], () => {
        resolve(require('../views/SaleCategory/Form/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  
  { path: '/customertags', component: (resolve) => {
      require.ensure(['../views/CustomerTag/Index.vue'], () => {
        resolve(require('../views/CustomerTag/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/customertags/form', component: (resolve) => {
      require.ensure(['../views/CustomerTag/Form/Index.vue'], () => {
        resolve(require('../views/CustomerTag/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/salestags', component: (resolve) => {
      require.ensure(['../views/SalesTag/Index.vue'], () => {
        resolve(require('../views/SalesTag/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/salestags/form', component: (resolve) => {
      require.ensure(['../views/SalesTag/Form/Index.vue'], () => {
        resolve(require('../views/SalesTag/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/contacttags', component: (resolve) => {
      require.ensure(['../views/ContactTag/Index.vue'], () => {
        resolve(require('../views/ContactTag/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/contacttags/form', component: (resolve) => {
      require.ensure(['../views/ContactTag/Form/Index.vue'], () => {
        resolve(require('../views/ContactTag/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/communicationtemplates', component: (resolve) => {
      require.ensure(['../views/CommunicationTemplate/Index.vue'], () => {
        resolve(require('../views/CommunicationTemplate/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/communicationtemplates/form', component: (resolve) => {
      require.ensure(['../views/CommunicationTemplate/Form/Index.vue'], () => {
        resolve(require('../views/CommunicationTemplate/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/discountcoupons', component: (resolve) => {
      require.ensure(['../views/DiscountCoupon/Index.vue'], () => {
        resolve(require('../views/DiscountCoupon/Index.vue'))
      })
  }, meta: { requiresAuth: true } },
  { path: '/discountcoupons/form', component: (resolve) => {
      require.ensure(['../views/DiscountCoupon/Form/Index.vue'], () => {
        resolve(require('../views/DiscountCoupon/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/usergroups', component: (resolve) => {
      require.ensure(['../views/UserGroup/Index.vue'], () => {
        resolve(require('../views/UserGroup/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/usergroups/form', component: (resolve) => {
      require.ensure(['../views/UserGroup/Form/Index.vue'], () => {
        resolve(require('../views/UserGroup/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/devicelist', component: (resolve) => {
      require.ensure(['../views/DeviceList/Index.vue'], () => {
        resolve(require('../views/DeviceList/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/tailoringcategories', component: (resolve) => {
      require.ensure(['../views/ItemCategory/TailoringCategory.vue'], () => {
        resolve(require('../views/ItemCategory/TailoringCategory.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tailoringcategories/form', component: (resolve) => {
      require.ensure(['../views/ItemCategory/Form/Index.vue'], () => {
        resolve(require('../views/ItemCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/tailoringcollections', component: (resolve) => {
      require.ensure(['../views/TailoringCollection/Index.vue'], () => {
        resolve(require('../views/TailoringCollection/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tailoringcollections/form', component: (resolve) => {
      require.ensure(['../views/TailoringCollection/Form/Index.vue'], () => {
        resolve(require('../views/TailoringCollection/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/tailoringtrialtype', component: (resolve) => {
      require.ensure(['../views/TailoringTrialType/Index.vue'], () => {
        resolve(require('../views/TailoringTrialType/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tailoringtrialtype/form', component: (resolve) => {
      require.ensure(['../views/TailoringTrialType/Form/Index.vue'], () => {
        resolve(require('../views/TailoringTrialType/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/tailoringsizes', component: (resolve) => {
      require.ensure(['../views/TailoringSize/Index.vue'], () => {
        resolve(require('../views/TailoringSize/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/tailoringsizes/form', component: (resolve) => {
      require.ensure(['../views/TailoringSize/Form/Index.vue'], () => {
        resolve(require('../views/TailoringSize/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/measurementtemplates', component: (resolve) => {
      require.ensure(['../views/MeasurementTemplate/Index.vue'], () => {
        resolve(require('../views/MeasurementTemplate/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/measurementtemplates/form', component: (resolve) => {
      require.ensure(['../views/MeasurementTemplate/Form/Index.vue'], () => {
        resolve(require('../views/MeasurementTemplate/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/mastermsmtsheet', component: (resolve) => {
      require.ensure(['../views/MasterMeasurementSheet/Index.vue'], () => {
        resolve(require('../views/MasterMeasurementSheet/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  

  { path: '/productionstages', component: (resolve) => {
      require.ensure(['../views/ProductionStage/Index.vue'], () => {
        resolve(require('../views/ProductionStage/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/productionstages/form', component: (resolve) => {
      require.ensure(['../views/ProductionStage/Form/Index.vue'], () => {
        resolve(require('../views/ProductionStage/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/mastertailoringsalesform', component: (resolve) => {
      require.ensure(['../views/TailoringMaster/Index.vue'], () => {
        resolve(require('../views/TailoringMaster/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/mastertailoringsalesform/form', component: (resolve) => {
      require.ensure(['../views/TailoringMaster/Form/Index.vue'], () => {
        resolve(require('../views/TailoringMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/leavemaster', component: (resolve) => {
      require.ensure(['../views/LeaveMaster/Index.vue'], () => {
        resolve(require('../views/LeaveMaster/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/leavemaster/form', component: (resolve) => {
      require.ensure(['../views/LeaveMaster/Form/Index.vue'], () => {
        resolve(require('../views/LeaveMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/overtimeslabs', component: (resolve) => {
      require.ensure(['../views/OvertimeSlab/Index.vue'], () => {
        resolve(require('../views/OvertimeSlab/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/overtimeslabs/form', component: (resolve) => {
      require.ensure(['../views/OvertimeSlab/Form/Index.vue'], () => {
        resolve(require('../views/OvertimeSlab/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/holidaylist', component: (resolve) => {
      require.ensure(['../views/HolidayList/Index.vue'], () => {
        resolve(require('../views/HolidayList/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/holidaylist/form', component: (resolve) => {
      require.ensure(['../views/HolidayList/Form/Index.vue'], () => {
        resolve(require('../views/HolidayList/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/designations', component: (resolve) => {
      require.ensure(['../views/Designation/Index.vue'], () => {
        resolve(require('../views/Designation/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/designations/form', component: (resolve) => {
      require.ensure(['../views/Designation/Form/Index.vue'], () => {
        resolve(require('../views/Designation/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/employees', component: (resolve) => {
      require.ensure(['../views/Employees/Index.vue'], () => {
        resolve(require('../views/Employees/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/employees/form', component: (resolve) => {
      require.ensure(['../views/Employees/Form/Index.vue'], () => {
        resolve(require('../views/Employees/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/genericcontacts', component: (resolve) => {
      require.ensure(['../views/GenericContact/Index.vue'], () => {
        resolve(require('../views/GenericContact/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/genericcontacts/form', component: (resolve) => {
      require.ensure(['../views/GenericContact/Form/Index.vue'], () => {
        resolve(require('../views/GenericContact/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/manageteams', component: (resolve) => {
      require.ensure(['../views/TeamList/Index.vue'], () => {
        resolve(require('../views/TeamList/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/manageteams/form', component: (resolve) => {
      require.ensure(['../views/TeamList/Form/Index.vue'], () => {
        resolve(require('../views/TeamList/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/leaveapplications', component: (resolve) => {
      require.ensure(['../views/LeaveApplication/Index.vue'], () => {
        resolve(require('../views/LeaveApplication/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/leaveapplications/form', component: (resolve) => {
      require.ensure(['../views/LeaveApplication/Form/Index.vue'], () => {
        resolve(require('../views/LeaveApplication/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/attendanceentry', component: (resolve) => {
      require.ensure(['../views/AttendanceEntry/Index.vue'], () => {
        resolve(require('../views/AttendanceEntry/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/attendanceentry/form', component: (resolve) => {
      require.ensure(['../views/AttendanceEntry/Form/Index.vue'], () => {
        resolve(require('../views/AttendanceEntry/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/banknames', component: (resolve) => {
      require.ensure(['../views/BankMaster/Index.vue'], () => {
        resolve(require('../views/BankMaster/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/banknames/form', component: (resolve) => {
      require.ensure(['../views/BankMaster/Form/Index.vue'], () => {
        resolve(require('../views/BankMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/paymentmodes', component: (resolve) => {
      require.ensure(['../views/PaymentMode/Index.vue'], () => {
        resolve(require('../views/PaymentMode/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/paymentmodes/form', component: (resolve) => {
      require.ensure(['../views/PaymentMode/Form/Index.vue'], () => {
        resolve(require('../views/PaymentMode/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/currencies', component: (resolve) => {
      require.ensure(['../views/CurrencyExchange/Index.vue'], () => {
        resolve(require('../views/CurrencyExchange/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/currencies/form', component: (resolve) => {
      require.ensure(['../views/CurrencyExchange/Form/Index.vue'], () => {
        resolve(require('../views/CurrencyExchange/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/expenseaccounts', component: (resolve) => {
      require.ensure(['../views/ExpenseCategory/Index.vue'], () => {
        resolve(require('../views/ExpenseCategory/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/expenseaccounts/form', component: (resolve) => {
      require.ensure(['../views/ExpenseCategory/Form/Index.vue'], () => {
        resolve(require('../views/ExpenseCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/expensejournals', component: (resolve) => {
      require.ensure(['../views/ExpenseJournal/Index.vue'], () => {
        resolve(require('../views/ExpenseJournal/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/expensejournals/form', component: (resolve) => {
      require.ensure(['../views/ExpenseJournal/Form/Index.vue'], () => {
        resolve(require('../views/ExpenseJournal/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/contraentry', component: (resolve) => {
      require.ensure(['../views/ContraEntry/Index.vue'], () => {
        resolve(require('../views/ContraEntry/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/contraentry/form', component: (resolve) => {
      require.ensure(['../views/ContraEntry/Form/Index.vue'], () => {
        resolve(require('../views/ContraEntry/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/fabriccategories', component: (resolve) => {
      require.ensure(['../views/ItemCategory/FabricCategory.vue'], () => {
        resolve(require('../views/ItemCategory/FabricCategory.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/fabriccategories/form', component: (resolve) => {
      require.ensure(['../views/ItemCategory/Form/Index.vue'], () => {
        resolve(require('../views/ItemCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/retailcategories', component: (resolve) => {
      require.ensure(['../views/ItemCategory/RetailCategory.vue'], () => {
        resolve(require('../views/ItemCategory/RetailCategory.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/retailcategories/form', component: (resolve) => {
      require.ensure(['../views/ItemCategory/Form/Index.vue'], () => {
        resolve(require('../views/ItemCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/rawmaterialcategories', component: (resolve) => {
      require.ensure(['../views/ItemCategory/RawMaterialCategory.vue'], () => {
        resolve(require('../views/ItemCategory/RawMaterialCategory.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/rawmaterialcategories/form', component: (resolve) => {
      require.ensure(['../views/ItemCategory/Form/Index.vue'], () => {
        resolve(require('../views/ItemCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/assetcategories', component: (resolve) => {
      require.ensure(['../views/ItemCategory/AssetCategory.vue'], () => {
        resolve(require('../views/ItemCategory/AssetCategory.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/assetcategories/form', component: (resolve) => {
      require.ensure(['../views/ItemCategory/Form/Index.vue'], () => {
        resolve(require('../views/ItemCategory/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/fabricpriceslabs', component: (resolve) => {
      require.ensure(['../views/FabricPriceSlab/Index.vue'], () => {
        resolve(require('../views/FabricPriceSlab/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/fabricpriceslabs/form', component: (resolve) => {
      require.ensure(['../views/FabricPriceSlab/Form/Index.vue'], () => {
        resolve(require('../views/FabricPriceSlab/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/inventoryvariants', component: (resolve) => {
      require.ensure(['../views/InventoryVariant/Index.vue'], () => {
        resolve(require('../views/InventoryVariant/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/inventoryvariants/form', component: (resolve) => {
      require.ensure(['../views/InventoryVariant/Form/Index.vue'], () => {
        resolve(require('../views/InventoryVariant/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/inventoryracks', component: (resolve) => {
    require.ensure(['../views/InventoryRacks/Index.vue'], () => {
      resolve(require('../views/InventoryRacks/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/inventoryracks/form', component: (resolve) => {
      require.ensure(['../views/InventoryRacks/Form/Index.vue'], () => {
        resolve(require('../views/InventoryRacks/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  
  { path: '/vendors', component: (resolve) => {
      require.ensure(['../views/Vendor/Index.vue'], () => {
        resolve(require('../views/Vendor/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/vendors/form', component: (resolve) => {
      require.ensure(['../views/Vendor/Form/Index.vue'], () => {
        resolve(require('../views/Vendor/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/inventoryproducts', component: (resolve) => {
      require.ensure(['../views/InventoryMaster/Index.vue'], () => {
        resolve(require('../views/InventoryMaster/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/inventoryproducts/form', component: (resolve) => {
      require.ensure(['../views/InventoryMaster/Form/Index.vue'], () => {
        resolve(require('../views/InventoryMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/purchaseorders', component: (resolve) => {
      require.ensure(['../views/InventoryOrder/Index.vue'], () => {
        resolve(require('../views/InventoryOrder/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/purchaseorders/form', component: (resolve) => {
      require.ensure(['../views/InventoryOrder/Form/Index.vue'], () => {
        resolve(require('../views/InventoryOrder/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/purchaseinvoices', component: (resolve) => {
      require.ensure(['../views/InventoryInvoice/Index.vue'], () => {
        resolve(require('../views/InventoryInvoice/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/purchaseinvoices/form', component: (resolve) => {
      require.ensure(['../views/InventoryInvoice/Form/Index.vue'], () => {
        resolve(require('../views/InventoryInvoice/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/vendorpayment', component: (resolve) => {
      require.ensure(['../views/VendorPayment/Index.vue'], () => {
        resolve(require('../views/VendorPayment/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/vendorpayment/form', component: (resolve) => {
      require.ensure(['../views/VendorPayment/Form/Index.vue'], () => {
        resolve(require('../views/VendorPayment/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/intrabranchtransfer', component: (resolve) => {
      require.ensure(['../views/InventoryIntraBranch/Index.vue'], () => {
        resolve(require('../views/InventoryIntraBranch/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/intrabranchtransfer/form', component: (resolve) => {
      require.ensure(['../views/InventoryIntraBranch/Form/Index.vue'], () => {
        resolve(require('../views/InventoryIntraBranch/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/externalsourcing', component: (resolve) => {
      require.ensure(['../views/InventorySourcing/Index.vue'], () => {
        resolve(require('../views/InventorySourcing/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/externalsourcing/form', component: (resolve) => {
      require.ensure(['../views/InventorySourcing/Form/Index.vue'], () => {
        resolve(require('../views/InventorySourcing/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/inventorycheck', component: (resolve) => {
      require.ensure(['../views/InventoryStockCheck/Index.vue'], () => {
        resolve(require('../views/InventoryStockCheck/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/inventorycheck/form', component: (resolve) => {
      require.ensure(['../views/InventoryStockCheck/Form/Index.vue'], () => {
        resolve(require('../views/InventoryStockCheck/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/customers', component: (resolve) => {
      require.ensure(['../views/CustomerMaster/Index.vue'], () => {
        resolve(require('../views/CustomerMaster/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/customers/form', component: (resolve) => {
      require.ensure(['../views/CustomerMaster/Form/Index.vue'], () => {
        resolve(require('../views/CustomerMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/salesestimates', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Estimate.vue'], () => {
        resolve(require('../views/SaleMaster/Estimate.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/salesestimates/form', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Form/Index.vue'], () => {
        resolve(require('../views/SaleMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/salesorders', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Order.vue'], () => {
        resolve(require('../views/SaleMaster/Order.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/salesorders/form', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Form/Index.vue'], () => {
        resolve(require('../views/SaleMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/salesinvoices', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Invoice.vue'], () => {
        resolve(require('../views/SaleMaster/Invoice.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/salesinvoices/form', component: (resolve) => {
      require.ensure(['../views/SaleMaster/Form/Index.vue'], () => {
        resolve(require('../views/SaleMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/manufacturingorders', component: (resolve) => {
      require.ensure(['../views/SaleMaster/MO.vue'], () => {
        resolve(require('../views/SaleMaster/MO.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/manufacturingorders/form', component: (resolve) => {
    require.ensure(['../views/SaleMaster/Form/Index.vue'], () => {
      resolve(require('../views/SaleMaster/Form/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/customerpayment', component: (resolve) => {
      require.ensure(['../views/CustomerPayment/Index.vue'], () => {
        resolve(require('../views/CustomerPayment/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/customerpayment/form', component: (resolve) => {
      require.ensure(['../views/CustomerPayment/Form/Index.vue'], () => {
        resolve(require('../views/CustomerPayment/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/estoreorders', component: (resolve) => {
      require.ensure(['../views/EStoreOrder/Index.vue'], () => {
        resolve(require('../views/EStoreOrder/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/purchaserequests', component: (resolve) => {
      require.ensure(['../views/PurchaseRequest/Index.vue'], () => {
        resolve(require('../views/PurchaseRequest/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/manageworkorders', component: (resolve) => {
      require.ensure(['../views/WorkOrder/MasterWindow.vue'], () => {
        resolve(require('../views/WorkOrder/MasterWindow.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/giftcards', component: (resolve) => {
      require.ensure(['../views/GiftCard/Index.vue'], () => {
        resolve(require('../views/GiftCard/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/giftcards/form', component: (resolve) => {
      require.ensure(['../views/GiftCard/Form/Index.vue'], () => {
        resolve(require('../views/GiftCard/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/deliveryreceipts', component: (resolve) => {
      require.ensure(['../views/SaleDelivery/Index.vue'], () => {
        resolve(require('../views/SaleDelivery/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/deliveryreceipts/form', component: (resolve) => {
      require.ensure(['../views/SaleDelivery/Form/Index.vue'], () => {
        resolve(require('../views/SaleDelivery/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/issuerawmaterials', component: (resolve) => {
      require.ensure(['../views/ProductionItemIssue/Index.vue'], () => {
        resolve(require('../views/ProductionItemIssue/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/workerstatus', component: (resolve) => {
      require.ensure(['../views/ProductionWorkerStatus/Index.vue'], () => {
        resolve(require('../views/ProductionWorkerStatus/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/workerdues', component: (resolve) => {
      require.ensure(['../views/ProductionWorkerDues/Index.vue'], () => {
        resolve(require('../views/ProductionWorkerDues/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/transferworkorder', component: (resolve) => {
      require.ensure(['../views/TransferWorkOrder/Index.vue'], () => {
        resolve(require('../views/TransferWorkOrder/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/transferworkorder/form', component: (resolve) => {
      require.ensure(['../views/TransferWorkOrder/Form/Index.vue'], () => {
        resolve(require('../views/TransferWorkOrder/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/custombatch', component: (resolve) => {
      require.ensure(['../views/Production/CustomBatch/Index.vue'], () => {
        resolve(require('../views/Production/CustomBatch/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/custombatch/form', component: (resolve) => {
      require.ensure(['../views/Production/CustomBatch/Form/Index.vue'], () => {
        resolve(require('../views/Production/CustomBatch/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/productionworkorders', component: (resolve) => {
      require.ensure(['../views/Production/DirectSearchWindow.vue'], () => {
        resolve(require('../views/Production/DirectSearchWindow.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/groupworkorders', component: (resolve) => {
    require.ensure(['../views/Production/GroupWorkOrderList.vue'], () => {
      resolve(require('../views/Production/GroupWorkOrderList.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/groupworkorders/viewlist', component: (resolve) => {
  require.ensure(['../views/Production/GroupWorkOrderListDetail.vue'], () => {
    resolve(require('../views/Production/GroupWorkOrderListDetail.vue'))
  })
},  meta: { requiresAuth: true } },

  { path: '/fabricsegregation', component: (resolve) => {
      require.ensure(['../views/InventorySeparation/Index.vue'], () => {
        resolve(require('../views/InventorySeparation/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/fabricsegregation/form', component: (resolve) => {
      require.ensure(['../views/InventorySeparation/Form/Index.vue'], () => {
        resolve(require('../views/InventorySeparation/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/processbatch', component: (resolve) => {
      require.ensure(['../views/Production/ProcessBatch.vue'], () => {
        resolve(require('../views/Production/ProcessBatch.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/processbatch/list', component: (resolve) => {
      require.ensure(['../views/Production/WorkOrderList.vue'], () => {
        resolve(require('../views/Production/WorkOrderList.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/pendingworkorderapproval', component: (resolve) => {
      require.ensure(['../views/Production/PendingApprovals.vue'], () => {
        resolve(require('../views/Production/PendingApprovals.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/productioncapacity', component: (resolve) => {
      require.ensure(['../views/ProductionCapacity/Index.vue'], () => {
        resolve(require('../views/ProductionCapacity/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/productioncapacity/form', component: (resolve) => {
      require.ensure(['../views/ProductionCapacity/Form/Index.vue'], () => {
        resolve(require('../views/ProductionCapacity/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/employeeloans', component: (resolve) => {
    require.ensure(['../views/EmployeeLoan/Index.vue'], () => {
      resolve(require('../views/EmployeeLoan/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/employeeloans/form', component: (resolve) => {
      require.ensure(['../views/EmployeeLoan/Form/Index.vue'], () => {
        resolve(require('../views/EmployeeLoan/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/payroll', component: (resolve) => {
    require.ensure(['../views/EmployeePayroll/Index.vue'], () => {
      resolve(require('../views/EmployeePayroll/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/payroll/form', component: (resolve) => {
      require.ensure(['../views/EmployeePayroll/Form/Index.vue'], () => {
        resolve(require('../views/EmployeePayroll/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/singlepayrollform', component: (resolve) => {
      require.ensure(['../views/EmployeePayroll/Form/Index.vue'], () => {
        resolve(require('../views/EmployeePayroll/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/readyorders', component: (resolve) => {
      require.ensure(['../views/ReadyOrders/Index.vue'], () => {
        resolve(require('../views/ReadyOrders/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/salesappointments', component: (resolve) => {
      require.ensure(['../views/Planner/StoreView.vue'], () => {
        resolve(require('../views/Planner/StoreView.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/productionplanner', component: (resolve) => {
      require.ensure(['../views/Planner/ProductionView.vue'], () => {
        resolve(require('../views/Planner/ProductionView.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/prioritylist', component: (resolve) => {
      require.ensure(['../views/Planner/PriorityView.vue'], () => {
        resolve(require('../views/Planner/PriorityView.vue'))
      })
  },  meta: { requiresAuth: true } },  

  { path: '/customeranalysis', component: (resolve) => {
    require.ensure(['../views/Reports/Sales/CustomerAnalysis/Index.vue'], () => {
      resolve(require('../views/Reports/Sales/CustomerAnalysis/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/salessummary', component: (resolve) => {
    require.ensure(['../views/Reports/Sales/SalesSummary/Index.vue'], () => {
      resolve(require('../views/Reports/Sales/SalesSummary/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/customerbalances', component: (resolve) => {
    require.ensure(['../views/Reports/Sales/CustomerOverdues/Index.vue'], () => {
      resolve(require('../views/Reports/Sales/CustomerOverdues/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/salesanalysis', component: (resolve) => {
    require.ensure(['../views/Reports/Sales/SalesAnalysis/Index.vue'], () => {
      resolve(require('../views/Reports/Sales/SalesAnalysis/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/supplierpayables', component: (resolve) => {
    require.ensure(['../views/Reports/Accounts/VendorPayables/Index.vue'], () => {
      resolve(require('../views/Reports/Accounts/VendorPayables/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/cashflow', component: (resolve) => {
    require.ensure(['../views/Reports/Accounts/MoneySummary/Index.vue'], () => {
      resolve(require('../views/Reports/Accounts/MoneySummary/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/incomevsexpense', component: (resolve) => {
    require.ensure(['../views/Reports/Accounts/IncomeVSExpense/Index.vue'], () => {
      resolve(require('../views/Reports/Accounts/IncomeVSExpense/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/taxreport', component: (resolve) => {
    require.ensure(['../views/Reports/Accounts/TaxReport/Index.vue'], () => {
      resolve(require('../views/Reports/Accounts/TaxReport/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/closingstock', component: (resolve) => {
    require.ensure(['../views/Reports/Inventory/ClosingStock/Index.vue'], () => {
      resolve(require('../views/Reports/Inventory/ClosingStock/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/inventoryanalysis', component: (resolve) => {
    require.ensure(['../views/Reports/Inventory/Analysis/Index.vue'], () => {
      resolve(require('../views/Reports/Inventory/Analysis/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/agingreport', component: (resolve) => {
    require.ensure(['../views/Reports/Inventory/AgingStock/Index.vue'], () => {
      resolve(require('../views/Reports/Inventory/AgingStock/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/dailyattendancereport', component: (resolve) => {
    require.ensure(['../views/Reports/HR/DailyAttendance/Index.vue'], () => {
      resolve(require('../views/Reports/HR/DailyAttendance/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/expiringdocuments', component: (resolve) => {
    require.ensure(['../views/Reports/HR/ExpiringDocument/Index.vue'], () => {
      resolve(require('../views/Reports/HR/ExpiringDocument/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/customeranniversarywishes', component: (resolve) => {
    require.ensure(['../views/Reports/HR/CustomerAnniversary/Index.vue'], () => {
      resolve(require('../views/Reports/HR/CustomerAnniversary/Index.vue'))
    })
  },  meta: { requiresAuth: true } },

  { path: '/assets', component: (resolve) => {
    require.ensure(['../views/AssetMaster/Index.vue'], () => {
      resolve(require('../views/AssetMaster/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/assets/form', component: (resolve) => {
      require.ensure(['../views/AssetMaster/Form/Index.vue'], () => {
        resolve(require('../views/AssetMaster/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/productionanalysis', component: (resolve) => {
      require.ensure(['../views/Reports/ProductionAnalysis/Index.vue'], () => {
        resolve(require('../views/Reports/ProductionAnalysis/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/dayendreport', component: (resolve) => {
      require.ensure(['../views/Reports/DayEnd/Index.vue'], () => {
        resolve(require('../views/Reports/DayEnd/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/intrabranchtransferreport', component: (resolve) => {
    require.ensure(['../views/Reports/Inventory/IntraBranch/Index.vue'], () => {
      resolve(require('../views/Reports/Inventory/IntraBranch/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/issuematerialreport', component: (resolve) => {
    require.ensure(['../views/Reports/Inventory/IssueMaterial/Index.vue'], () => {
      resolve(require('../views/Reports/Inventory/IssueMaterial/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/exportexpense', component: (resolve) => {
      require.ensure(['../views/ExportExpense/Index.vue'], () => {
        resolve(require('../views/ExportExpense/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/exportinventorydiscount', component: (resolve) => {
      require.ensure(['../views/ImportInventoryDiscount/Index.vue'], () => {
        resolve(require('../views/ImportInventoryDiscount/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/importcustomerlist', component: (resolve) => {
      require.ensure(['../views/ImportCustomerList/Index.vue'], () => {
        resolve(require('../views/ImportCustomerList/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  
  { path: '/accountexpired', component: (resolve) => {
      require.ensure(['../views/AccountExpired/Index.vue'], () => {
        resolve(require('../views/AccountExpired/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/bankstatement', component: (resolve) => {
      require.ensure(['../views/BankStatement/Index.vue'], () => {
        resolve(require('../views/BankStatement/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/ecampaigns', component: (resolve) => {
      require.ensure(['../views/Campaign/Index.vue'], () => {
        resolve(require('../views/Campaign/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/ecampaigns/form', component: (resolve) => {
      require.ensure(['../views/Campaign/Form/Index.vue'], () => {
        resolve(require('../views/Campaign/Form/Index.vue'))
      })
  },  meta: { requiresAuth: true } },

  { path: '/shipmentpartners', component: (resolve) => {
      require.ensure(['../views/ShipmentPartner/Index.vue'], () => {
        resolve(require('../views/ShipmentPartner/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/shipmentpartners/form', component: (resolve) => {
    require.ensure(['../views/ShipmentPartner/Form/Index.vue'], () => {
      resolve(require('../views/ShipmentPartner/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/handloomclusters', component: (resolve) => {
    require.ensure(['../views/HandloomCluster/Index.vue'], () => {
      resolve(require('../views/HandloomCluster/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/handloomclusters/form', component: (resolve) => {
    require.ensure(['../views/HandloomCluster/Form/Index.vue'], () => {
      resolve(require('../views/HandloomCluster/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/lettertemplates', component: (resolve) => {
    require.ensure(['../views/LetterTemplate/Index.vue'], () => {
      resolve(require('../views/LetterTemplate/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/lettertemplates/form', component: (resolve) => {
    require.ensure(['../views/LetterTemplate/Form/Index.vue'], () => {
      resolve(require('../views/LetterTemplate/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/damagedgoods', component: (resolve) => {
    require.ensure(['../views/LostDamaged/Index.vue'], () => {
      resolve(require('../views/LostDamaged/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/damagedgoods/form', component: (resolve) => {
    require.ensure(['../views/LostDamaged/Form/Index.vue'], () => {
      resolve(require('../views/LostDamaged/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/expensebills', component: (resolve) => {
    require.ensure(['../views/ExpenseBill/Index.vue'], () => {
      resolve(require('../views/ExpenseBill/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/expensebills/form', component: (resolve) => {
    require.ensure(['../views/ExpenseBill/Form/Index.vue'], () => {
      resolve(require('../views/ExpenseBill/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

/** ESTORE MODULES **/

{ path: '/estorecategories', component: (resolve) => {
    require.ensure(['../views/EStoreCategory/Index.vue'], () => {
      resolve(require('../views/EStoreCategory/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/estorecategories/form', component: (resolve) => {
    require.ensure(['../views/EStoreCategory/Form/Index.vue'], () => {
      resolve(require('../views/EStoreCategory/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estoretopmenu', component: (resolve) => {
    require.ensure(['../views/EStoreTopMenu/Index.vue'], () => {
      resolve(require('../views/EStoreTopMenu/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/estoretopmenu/form', component: (resolve) => {
    require.ensure(['../views/EStoreTopMenu/Form/Index.vue'], () => {
      resolve(require('../views/EStoreTopMenu/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estoreproducts', component: (resolve) => {
    require.ensure(['../views/EStoreProduct/Index.vue'], () => {
      resolve(require('../views/EStoreProduct/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/estoreproducts/form', component: (resolve) => {
    require.ensure(['../views/EStoreProduct/Form/Index.vue'], () => {
      resolve(require('../views/EStoreProduct/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estorehomepage', component: (resolve) => {
    require.ensure(['../views/EStoreHomePage/Index.vue'], () => {
      resolve(require('../views/EStoreHomePage/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estorehomepage/form', component: (resolve) => {
    require.ensure(['../views/EStoreHomePage/Form/Index.vue'], () => {
      resolve(require('../views/EStoreHomePage/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estorecatalogs', component: (resolve) => {
    require.ensure(['../views/EStoreCatalog/Index.vue'], () => {
      resolve(require('../views/EStoreCatalog/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/estorecatalogs/form', component: (resolve) => {
    require.ensure(['../views/EStoreCatalog/Form/Index.vue'], () => {
      resolve(require('../views/EStoreCatalog/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

{ path: '/estorenews', component: (resolve) => {
    require.ensure(['../views/News/Index.vue'], () => {
      resolve(require('../views/News/Index.vue'))
    })
},  meta: { requiresAuth: true } },
{ path: '/estorenews/form', component: (resolve) => {
    require.ensure(['../views/News/Form/Index.vue'], () => {
      resolve(require('../views/News/Form/Index.vue'))
    })
},  meta: { requiresAuth: true } },

/** END ESTORE MODULES **/

  { path: '/', component: (resolve) => {
      require.ensure(['../views/Dashboard/Index.vue'], () => {
        resolve(require('../views/Dashboard/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
    
  { path: '/orderprogress', component: (resolve) => {
      require.ensure(['../views/OrderProgressWindow/Index.vue'], () => {
        resolve(require('../views/OrderProgressWindow/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
    
  { path: '/databackup', component: (resolve) => {
      require.ensure(['../views/DataBackup/Index.vue'], () => {
        resolve(require('../views/DataBackup/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/master-login-request/', component: (resolve) => {
    require.ensure(['../views/MasterLoginRequest/Index.vue'], () => {
      resolve(require('../views/MasterLoginRequest/Index.vue'))
    })
  },  meta: { requiresAuth: false } },  

  { path: '/importtallydata', component: (resolve) => {
    require.ensure(['../views/TallyImport/Index.vue'], () => {
      resolve(require('../views/TallyImport/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '*', component: (resolve) => {
      require.ensure(['../views/Error404.vue'], () => {
        resolve(require('../views/Error404.vue'))
      })
  },  meta: { requiresAuth: true } }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js